import { z } from 'zod';
const id = z.string().trim().min(1).max(128);
export const DATING_INTERESTS = [
    'sport',
    'music',
    'cinema',
    'travel',
    'books',
    'games',
    'technology',
    'art',
    'cooking',
    'nature',
    'dancing',
    'photography',
    'animals',
    'business',
    'languages',
    'volunteering'
];
export const datingGenderSchema = z.enum(['man', 'woman', 'non_binary']);
export const datingGoalSchema = z.enum([
    'serious_relationship',
    'dating',
    'friendship',
    'communication'
]);
export const datingInterestSchema = z.enum(DATING_INTERESTS);
/** Суперлайк — лайк подписчика ANDRESOT Premium: его анкета встаёт первой у адресата. */
export const datingDecisionKindSchema = z.enum(['like', 'pass', 'superlike']);
/** Сколько суперлайков в сутки у подписчика. */
export const DATING_SUPERLIKES_PER_DAY = 3;
export const datingProfileInputSchema = z
    .object({
    birthDate: z.string().date(),
    adultConfirmed: z.literal(true),
    gender: datingGenderSchema,
    city: z.string().trim().min(2).max(80),
    goal: datingGoalSchema,
    bio: z.string().trim().min(10).max(1_000),
    interests: z.array(datingInterestSchema).max(10),
    photoIds: z.array(id).min(1).max(6),
    preferredGenders: z.array(datingGenderSchema).min(1).max(3),
    preferredGoals: z.array(datingGoalSchema).min(1).max(4),
    minAge: z.number().int().min(18).max(100),
    maxAge: z.number().int().min(18).max(100),
    sameCityOnly: z.boolean(),
    visible: z.boolean()
})
    .strict()
    .refine((value) => value.minAge <= value.maxAge, { message: 'Неверный диапазон возраста' })
    .refine((value) => new Set(value.photoIds).size === value.photoIds.length, {
    message: 'Фотографии повторяются'
})
    .refine((value) => new Set(value.interests).size === value.interests.length, {
    message: 'Интересы повторяются'
});
export const datingDiscoveryQuerySchema = z.object({
    cursor: z.string().trim().min(1).max(512).optional(),
    limit: z.coerce.number().int().min(1).max(20).default(20)
});
export const datingDecisionInputSchema = z
    .object({ targetUserId: id, decision: datingDecisionKindSchema })
    .strict();
export const datingMatchParamsSchema = z.object({ matchId: id }).strict();
export const datingProfileParamsSchema = z.object({ userId: id }).strict();
export const datingReportInputSchema = z
    .object({
    reason: z.enum(['fake', 'spam', 'harassment', 'underage', 'inappropriate', 'other']),
    comment: z.string().trim().max(1_000).optional()
})
    .strict();
export const DATING_GENDER_TITLES = {
    man: 'Мужчина',
    woman: 'Женщина',
    non_binary: 'Небинарный человек'
};
export const DATING_GOAL_TITLES = {
    serious_relationship: 'Серьёзные отношения',
    dating: 'Свидания',
    friendship: 'Дружба',
    communication: 'Общение'
};
export const DATING_INTEREST_TITLES = {
    sport: 'Спорт',
    music: 'Музыка',
    cinema: 'Кино',
    travel: 'Путешествия',
    books: 'Книги',
    games: 'Игры',
    technology: 'Технологии',
    art: 'Искусство',
    cooking: 'Кулинария',
    nature: 'Природа',
    dancing: 'Танцы',
    photography: 'Фотография',
    animals: 'Животные',
    business: 'Бизнес',
    languages: 'Языки',
    volunteering: 'Волонтёрство'
};
//# sourceMappingURL=dating.js.map